import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getReportsCount = createAsyncThunk(
  'reports/getCount',
  async ({
    currentPage,
    limit,
    sortBy,
    sortOrder,
    searchQuery,
  }: {
    currentPage: number;
    limit: number;
    sortBy: 'email' | 'count';
    sortOrder: 'asc' | 'desc';
    searchQuery: string;
  }) => API.reportsCount.get({ currentPage, limit, sortBy, sortOrder, searchQuery }),
);

export const getAllReportsCountForExport = createAsyncThunk('reports/getAllForExport', async () =>
  API.reportsCount.getAll(),
);
